var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.withLink)?_c('router-link',{staticClass:"person-name",attrs:{"to":{
    name: 'person',
    params: {
      person_id: _vm.person.id
    }
  },"title":_vm.person.full_name}},[_vm._v(" "+_vm._s(_vm.person.first_name + ' ' + _vm.person.last_name)+" ")]):_c('span',{staticClass:"person-name"},[_vm._v(" "+_vm._s(_vm.person.first_name + ' ' + _vm.person.last_name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }